import { useT } from "@/i18n/LanguageProvider";

const EN = [
    "Used Cooking Oil",
    "E-Waste",
    "Paper & Cardboard",
    "Plastic",
    "Organic / Wet Waste",
    "Metal Scrap",
    "Textile",
    "Glass",
    "Construction Debris",
    "Biomedical",
];
const HI = [
    "Used Cooking Oil",
    "E-Waste",
    "पेपर और कार्डबोर्ड",
    "प्लास्टिक",
    "ऑर्गेनिक / गीला कचरा",
    "मेटल स्क्रैप",
    "टेक्सटाइल",
    "ग्लास",
    "कंस्ट्रक्शन डेब्रिस",
    "बायोमेडिकल",
];

export default function Marquee() {
    const { lang } = useT();
    const items = lang === "hi" ? HI : EN;
    const loop = [...items, ...items];
    return (
        <section
            data-testid="marquee-section"
            aria-hidden="true"
            className="relative py-8 md:py-10 bg-secondary border-y border-primary/10 overflow-hidden"
        >
            <div className="flex marquee-track whitespace-nowrap items-center">
                {loop.map((item, i) => (
                    <div key={`${item}-${i}`} className="flex items-center gap-8 md:gap-12 px-6 md:px-10">
                        <span className="text-xs md:text-sm uppercase tracking-[0.35em] text-primary/80 font-medium">
                            {item}
                        </span>
                        <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent/70" />
                    </div>
                ))}
            </div>
        </section>
    );
}
